import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://tpkafgnufwbqcdhiviwo.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InRwa2FmZ251ZndicWNkaGl2aXdvIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjQyNDI2MjMsImV4cCI6MjA3OTgxODYyM30.eWdrgGskoly4xwj2gTtVmr_Uot2llRcNCTNViQunAgo';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
